export default {
  productName: 'Історії',
  common: {
    back: 'Назад',
  },
  pages: {
    landing: {
      start: 'Почати!',
    },
    login: {
      error: 'Не вдалося увійти. Спробуйте ще раз.',
    },
    error404: {
      pageNotFound: 'Сторінку не знайдено!',
    },
    intro: {
      titles: ['Читай у будь-який час і в будь-якому місці', 'Преміум-контент', 'Пошук за віком'],
      descriptions: [
        'Насолоджуйся якісними історіями, створеними для дітей будь-якого віку.',
        'Отримай доступ до постійно зростаючої бібліотеки ексклюзивного контенту для твоїх дітей.',
        'Знаходь ідеальні історії відповідно до віку та інтересів твоєї дитини.',
      ],
      next: 'Далі',
      getStarted: 'Почати!',
      skip: 'Пропустити',
    },
  },
  components: {
    authentication: {
      magiclink: {
        welcome: 'Увійдіть до свого облікового запису',
        sendLink: 'Надіслати магічне посилання',
        verify: 'Підтвердити',
        backToLogin: 'Повернутися до входу',
        error: {
          generic: 'Щось пішло не так. Спробуйте ще раз.',
          invalid: 'Неправильна адреса або запит.',
          throttled: 'Занадто багато запитів. Зачекайте та спробуйте ще раз.',
          unknown: 'Сталася помилка. Спробуйте пізніше.',
        },
      },
    },
    mainUserBanner: {
      welcome: 'Ласкаво просимо, {name}',
      searchPlaceholder: 'Пошук книги...',
      crystals: 'Кристали',
      booksCompleted: 'Прочитано книг',
    },
    mainFooter: {
      copyright: '©2025 Appy Learning. Усі права захищені.',
    },
  },
};
